import React, { useEffect, useState } from "react";
import { addModule, deleteModule, editModule, getModules } from "../../services/apiService";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import Sidebar from "../Sidebar/Sidebar";
import { useNavigate } from 'react-router-dom';

export default function Modules() {
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [modules, setModules] = useState([])
  const [form, setForm] = useState({
    label: '',
    value: ''
  })
  const [editForm, setEditForm] = useState({
    label: '',
    value: ''
  })
  const [editId, setEditID] = useState(null)

  useEffect(() => {
    fetchModules()
  }, [])

  const fetchModules = async () => {
    const modules = await getModules();
    setModules(modules)
  }

  const handleAddModule = async () => {
    const response = await addModule(form)
    if(response) fetchModules()
    setModalVisible(false)
  }

  const handleEditModule = async () => {
    const response = await editModule(editForm, editId)
    if(response) fetchModules()
    setEditModalVisible(false)
  }

  const handleDelete = async (id) => {
    const response = await deleteModule(id)
    if(response) fetchModules()
  }

  const handleEdit = (item) => {
    setEditForm({
      label: item.label,
      value: item.value,
    })
    setEditID(item.id)
    setEditModalVisible(true)
  }

  return (
    <div style={{ flex: 1, height: "100vh", width: "100%" }}>
      <Row style={{ flex: 1, height: "100vh" }}>
        <Col sm={2} style={{ height: "100vh" }}>
          <Sidebar />
        </Col>
        <Col>
          <Container>
            <Container className="mt-3">
              <Row>
                <Col>
                  <div>
                    <Button
                      variant="primary"
                      onClick={() => setModalVisible(true)}
                    >
                      Modül Ekle
                    </Button>
                    <Table className="mt-3" striped bordered hover>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Modül adı</th>
                          <th>Modül Kısaltması</th>
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modules.map((item) => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.label}</td>
                            <td>{item.value}</td>
                            <td>
                              <Button variant="info" size="sm" onClick={() => handleEdit(item)}>
                                Düzenle
                              </Button>{" "}
                              <Button variant="danger" size="sm" onClick={() => handleDelete(item.id)}>
                                Sil
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </Container>

            <Modal show={modalVisible} onHide={() => setModalVisible(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Modül Ekle</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="formModuleName">
                    <Form.Label>Modül Adı</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Modül Adı"
                      onChange={(e) => setForm({
                        ...form,
                        label: e.target.value
                      })}
                    />
                  </Form.Group>
                  <Form.Group controlId="formModuleName">
                    <Form.Label>Modül Kısaltması</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Modül Kısaltması"
                      onChange={(e) => setForm({
                        ...form,
                        value: e.target.value
                      })}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setModalVisible(false)}
                >
                  Kapat
                </Button>
                <Button variant="primary" onClick={handleAddModule}>
                  Ekle
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={editModalVisible} onHide={() => setEditModalVisible(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Modül Ekle</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="formModuleName">
                    <Form.Label>Modül Adı</Form.Label>
                    <Form.Control
                      value={editForm.label}
                      type="text"
                      placeholder="Modül Adı"
                      onChange={(e) => setEditForm({
                        ...editForm,
                        label: e.target.value
                      })}
                    />
                  </Form.Group>
                  <Form.Group controlId="formModuleName">
                    <Form.Label>Modül Kısaltması</Form.Label>
                    <Form.Control
                      value={editForm.value}
                      type="text"
                      placeholder="Modül Kısaltması"
                      onChange={(e) => setEditForm({
                        ...editForm,
                        value: e.target.value
                      })}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setEditModalVisible(false)}
                >
                  Kapat
                </Button>
                <Button variant="primary" onClick={handleEditModule}>
                  Düzenle
                </Button>
              </Modal.Footer>
            </Modal>
          </Container>
        </Col>
      </Row>
    </div>
  );
}
